var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFoundImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 464.235,
    height: 273.515,
    viewBox: "0 0 464.235 273.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uqdico12ea",
    x1: 0.5,
    y1: -0.227,
    x2: 0.5,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10867"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10865"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10863"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6034",
    d: "M1271.764 815.136c3.122 4.416.546 10.161-2.562 13.394-3.821 3.975-7.7 3.361-9.472 6.875-2.137 4.247 2.412 7.37.039 11.81-1.457 2.728-3.458 2.078-6.355 5.542-3.531 4.219-.07 5.419-2.574 8.505-8.045 9.917-11.268 3.038-16.166 5.645-6.35 3.38-10.6 6.266-13.7 5.59-12.217-2.657-8.454-10.689-14.384-13.785-8.014-4.182-11.928-21.3-6.428-27.334 2.88-3.159 5.727-3.543 5.995-6.174.387-3.8-5.348-4.9-5.929-9.469-.66-5.18 6.214-7.688 5.19-12.064-1-4.266-8.052-4.113-8.505-7.159-.686-4.621 14.369-12.9 29.962-12.382 7.456.246 19.6 2.652 21.621 8.865 1.168 3.588-1.869 5.9-.158 10.537 1.245 3.369 4 5.254 7.642 7.682 3.459 2.305 10.261-3.89 15.784 3.922z",
    transform: "translate(-1134.118 -784.107)",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6035",
    d: "M1250.47 836.064c2.453-.123 3.7 16.234 2.281 18.379s-4.1 3.728-4.275 6.069.868 43.828 1.734 43.227 8.049-11.472 6.615-14-3.059-6.444-2.723-9.755.339-8.023 1.266-7.907.149 8.235.795 9.809.755 2.805 1.681 2.833.946-8.563 2.359-8.412.453 12.81-.034 15.154-2.145 10.434-3.677 13.413-6.189 6.1-6.3 7.118.632 25.175.632 25.175l-12.2.221s4.5-47.638 3.5-49.223-7.369-14.456-8.732-15.771-2.179-9.336-1.46-9.451 1.119 7.706 2.615 7.833 2.3-15.134 3.385-15-1.052 15.833-.468 16.8 3.987 6.778 5.117 6.655-.622-42.846.348-43.327 1.7-.082 2.294 4.388 1.752 14.237 2.422 14.225a3.663 3.663 0 0 0 2.376-2.464c.033-.982-.642-15.934.449-15.989z",
    transform: "translate(-1150.086 -807.815)",
    style: {
      fill: "#bdbdbd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10864"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6036",
    d: "M1754.518 911.119c-1.767 2.5-.309 5.753 1.45 7.583 2.164 2.25 4.361 1.9 5.363 3.893 1.21 2.4-1.365 4.172-.022 6.686.825 1.544 1.958 1.177 3.6 3.137 2 2.389.04 3.068 1.457 4.815 4.556 5.615 6.381 1.72 9.153 3.2 3.6 1.913 6 3.548 7.759 3.165 6.917-1.5 4.787-6.052 8.144-7.8 4.538-2.368 6.754-12.061 3.639-15.477-1.63-1.788-3.242-2.005-3.394-3.495-.219-2.15 3.028-2.775 3.357-5.361.374-2.933-3.518-4.353-2.938-6.83.564-2.416 4.559-2.328 4.815-4.053.388-2.617-8.136-7.3-16.964-7.01-4.221.139-11.1 1.5-12.241 5.019-.661 2.031 1.058 3.341.089 5.966-.7 1.908-2.263 2.975-4.326 4.349-1.959 1.294-5.813-2.206-8.941 2.213z",
    transform: "translate(-1389.775 -834.356)",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6037",
    d: "M1789.171 922.967c-1.388-.07-2.1 9.191-1.291 10.406s2.32 2.11 2.42 3.436-.491 24.814-.982 24.474-4.556-6.495-3.744-7.928a10.315 10.315 0 0 0 1.542-5.523c-.19-1.874-.192-4.542-.717-4.477s-.085 4.662-.45 5.553-.428 1.588-.952 1.6-.536-4.848-1.335-4.763-.256 7.252.019 8.579 1.215 5.908 2.082 7.594 3.5 3.455 3.568 4.03-.358 14.254-.358 14.254l6.906.125s-2.55-26.971-1.981-27.869 4.172-8.184 4.944-8.929 1.233-5.285.827-5.351-.634 4.363-1.48 4.435-1.3-8.568-1.917-8.492.6 8.964.265 9.512-2.257 3.838-2.9 3.768.352-24.258-.2-24.53-.961-.047-1.3 2.484-.992 8.061-1.371 8.053a2.074 2.074 0 0 1-1.346-1.395c-.014-.548.369-9.013-.249-9.046z",
    transform: "translate(-1403.331 -847.779)",
    style: {
      fill: "#bdbdbd"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 464",
    cx: 232.118,
    cy: 82.174,
    rx: 232.118,
    ry: 82.174,
    transform: "translate(0 109.167)",
    style: {
      fill: "url(#uqdico12ea)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10866"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2079",
    d: "M0 0h103.412v48.183a4.006 4.006 0 0 1-4.006 4.006h-95.4A4.006 4.006 0 0 1 0 48.183V0z",
    transform: "translate(174.471 81.921)",
    style: {
      fill: "#bad5ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6038",
    d: "M1501.832 952.624h-103.787a2.282 2.282 0 0 1-2.25-2.664l2.438-14.392h103.412l2.438 14.392a2.282 2.282 0 0 1-2.251 2.664z",
    transform: "translate(-1223.762 -853.647)",
    style: {
      fill: "#99c4f1"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundImage);
export default __webpack_public_path__ + "static/media/NotFoundImage.5672b457f0513c065c371233b53e962f.svg";
export { ForwardRef as ReactComponent };